import React,{useState} from 'react';
import PopConfirmInfo from '../_PopConfirmInfo';
import 'contents/assets/scss/page/mypage.scss';
import profileImg from 'contents/assets/img/@profile.png'
import mapImg from 'contents/assets/img/img_map.png'
function MyInfo() {
  const [modalOpen, setModalOpen] = useState(false);
  const [type, setType] = useState('id');
  const fnModal = (arg) => {
    if(arg === 'id') {
      setType('id')
    }else if(arg === 'pw') {
      setType('pw')
    }
    setModalOpen(true);
  }
  return (
    <main className="com_container com_member_info">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
        <h2 className='com_pg_tit icon menu12_11'>내 정보 <span className="bar"/><span className="point_txt">최교사103ㆍ수학</span></h2>
          <button onClick={() => {}} className="com_btn orange s btn_plus">수업 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            {/* 프로필 */}
            <div className="info_top">
              <div className="thumb">
                <img src={profileImg} alt="프로필 이미지" />
                <button className="btn_camera"></button>
              </div>
              <div className="com_input_wrap">
                <div className="input_row">
                  <input type="text" className="input" placeholder='교사명' />
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">교사</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">담임</label>
                  </div>
                </div>
                <div className="input_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <div className="check">
                    <input type="radio" name="rdo_sex" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">남</label>
                    <input type="radio" name="rdo_sex" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">여</label>
                  </div>
                </div>
                <div className="input_row">
                  <select className="select">
                    <option value="본사">본사</option>
                    <option value="지사">지사</option>
                  </select>
                  <select className="select">
                    <option value="고등부">고등부</option>
                    <option value="중등부">중등부</option>
                  </select>
                  <select className="select">
                    <option value="파트">파트</option>
                  </select>
                  <div className="check">
                    <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                    <label htmlFor="chk01">대면</label>
                    <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                    <label htmlFor="chk02">화상</label>
                  </div>
                </div>
              </div>

              <div className="btn_wrap">
                <button className="com_btn red xs">배정대기 : +468</button>
              </div>
            </div>

            {/* 상세 */}
            <table className='com_board_list type_row'>
              <colgroup>
                <col width="10%"/><col width="35%"/>
                <col width="10%"/><col width="35%"/>
              </colgroup>
              <tbody>
                <tr>
                  <th>아이디</th>
                  <td className='type_row'>ase234@naver.com <button onClick={() => fnModal('id')} className="com_btn gray xs btn_change">아이디 변경</button></td>
                  <th>영역 상세</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="영어">영어</option>
                        <option value="국어">국어</option>
                      </select>
                      <input type="text" className="input" defaultValue={`외국어영역`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>비밀번호</th>
                  <td className='type_row'>!@#**2344 <button onClick={() => {fnModal('pw')}} className="com_btn gray xs btn_change">비밀번호 변경</button></td>
                  <th>직급 / 상태</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="사원">사원</option>
                        <option value="대리">대리</option>
                      </select>
                      <select className="select wm">
                        <option value="호봉">호봉</option>
                      </select>
                      <select className="select wm">
                        <option value="B그룹">B그룹</option>
                      </select>
                      <select className="select wm">
                        <option value="내신A">내신A</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>휴대폰</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="교폰">교폰</option>
                      </select>
                      <input type="text" className="input" defaultValue={`010-2322-2222`} />
                    </div>
                  </td>
                  <th>시수 / 등급</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01">특별시수</label>
                      </div>
                      <input type="text" className="input" defaultValue={`44,000`} />
                      <input type="text" className="input" defaultValue={`***`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                  <th>시수 구성</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <span className="txt">장기수수료</span>
                      <input type="text" className="input ws" defaultValue={`5,000원`} />
                      <span className="txt">+ 지도관리수수료</span>
                      <input type="text" className="input ws" defaultValue={`5,000원`} />
                      <span className="txt">+ 원고료</span>
                      <input type="text" className="input ws" defaultValue={`5,000원`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>담임</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="담임 교사 선택">담임 교사 선택</option>
                      </select>
                    </div>
                  </td>
                  <th>학력 / 전공</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`한국방송통신대`} />
                      <input type="text" className="input" defaultValue={`미디어영상학과`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>계약일</th>
                  <td>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </td>
                  <th>논술등급</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="C등급">C등급</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>보험가입일 / 유지일</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    </div>
                  </td>
                  <th>계좌 정보</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="하나은행">하나은행</option>
                      </select>
                      <input type="text" className="input ws" defaultValue={`홍길동`} />
                      <input type="text" className="input wl" defaultValue={`828282918292`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>면접/소개/컨택자</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="면접자">면접자</option>
                      </select>
                      <select className="select wm">
                        <option value="소개자">소개자</option>
                      </select>
                      <select className="select wm">
                        <option value="컨택자">컨택자</option>
                      </select>
                    </div>
                  </td>
                  <th rowSpan={2}>경력</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                      **에듀에서 영어강사로 3년 근무<br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>거주지 주소</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" placeholder='주소' />
                      <button className="com_btn gray xs">우편번호</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td>
                    <input type="text" className="input" placeholder='주소' />
                  </td>
                  <th>메모</th>
                  <td>
                    <div className="txt_memo">메모메모메모</div>
                  </td>
                </tr>
                <tr>
                  <th>세부 계약 조건</th>
                  <td>
                    <div className="com_input_wrap">
                      <input type="text" className="input" defaultValue={`시수 추가시 수강료 인상`} />
                      <input type="text" className="input" defaultValue={`시수 추가시 수강료 인상`} />
                    </div>
                  </td>
                  <th>교육 수료 목록</th>
                  <td>
                    <div className="txt">
                      <p><span className="item_txt point">ㆍ2023 교사교육 / 2023,05,16 ~2023, 07, 05 / 수료</span></p>
                      <p><span className="item_txt">ㆍ2022 교사교육 교사 교육 / 수료</span></p>
                      <p><span className="item_txt">ㆍ2021 교사 대표교사 / 포기</span></p>
                    </div>
                  </td>
                </tr>
                <tr className='tr_wish'>
                  <th>수업 희망 요일</th>
                  <td>
                    <button className="btn_day active">월</button>
                    <button className="btn_day">화</button>
                    <button className="btn_day">수</button>
                    <button className="btn_day">목</button>
                    <button className="btn_day">금</button>
                    <button className="btn_day">토</button>
                    <button className="btn_day">일</button>
                  </td>
                  <td rowSpan={2} colSpan={2} className='td_notice'>
                    ㆍ최소 3개 이상 (1순위1개, 2순위2개)지역을 선택해야 합니다. <br />
                    ㆍ신규 교사는 거주지와 원거리 지역이 기본 선택 되어있습니다. 1년 후 수정 가능합니다. <br />
                    ㆍ거주지 이동시 희망 지역을 변경해야 합니다. <br />
                    ㆍ원거리 : 2순위에서 접하지 않은 지역.
                  </td>
                </tr>
                <tr className='tr_wish'>
                  <th>수업 희망 지역</th>
                  <td>
                    <span className="com_check_box">
                      <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                      <label htmlFor="chk010">원거리 강의 가능</label>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* 지역 */}
            <div className="area_wrap">
              <div className="map_box">
                <img src={mapImg} alt="지도 이미지" />
              </div>
              <div className="area_select">
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="서울">서울</option>
                      <option value="경기도">경기도</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">1순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                    </div>
                  </div>
                </div>
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="경기도">경기도</option>
                      <option value="서울">서울</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">2순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">고양시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">과천시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광명시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구리시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">군포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">김포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">남양주시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">부천시</label>
                    </div>
                  </div>
                </div>
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="경기도">경기도</option>
                      <option value="서울">서울</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">2순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">고양시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">과천시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광명시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구리시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">군포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">김포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">남양주시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">부천시</label>
                    </div>
                  </div>
                </div>
                <div className="com_btn_wrap center">
                  <div className="com_btn black s btn_plus_orange">지역 추가</div>
                </div>
              </div>
            </div>

            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">수정</button>
              <button className="com_btn orange s">저장</button>
              <button className="com_btn line gray s btn_enter">재입사</button>
              <button className="com_btn line gray s btn_enter">계약종료</button>
            </div>
          </section>
        </section>
      </div>
      <PopConfirmInfo open={modalOpen} close={() => setModalOpen(false)} type={type} />
    </main>
  );
}

export default MyInfo;
